import { Heading, Stack } from "@chakra-ui/react";

import CardMotion, { GridItemSetting } from "components/Chakra/Card/CardMotion";
import CardVariant, {
  CardType,
  ImageProps,
} from "components/Chakra/Card/CardVariant";
import CustomWrapper from "components/Chakra/CustomWrapper";
import { TAppRoutes } from "hooks/useRouter";

type ItemProp = {
  type: CardType;
  title: string;
  subtitle: string;
  image: ImageProps;
  gridItemSetting: GridItemSetting;
  to?: TAppRoutes;
  href?: string;
};

const items: Array<ItemProp> = [
  {
    type: "ORANGE_REVERT",
    title: "Portál Ulovdomov.cz",
    subtitle:
      "Jednička na trhu pronájmů. Největší nabídka od soukromých majitelů i realitních kanceláří na jednom místě.",
    image: {
      src: "/img/scenes/Sales/logoUD.png",
      style: {
        position: "relative",
        marginTop: "auto",
        bottom: "-10px",
        width: "60%",
      },
    },
    to: "/",
    gridItemSetting: { h: { base: "240px", md: "500px" }, flex: 1 },
  },
  {
    type: "GRAY_LIGHT_REVERT",
    title: "Služba Ideální nájemce",
    subtitle:
      "Pronajímatelům šetříme čas, starosti i peníze. Aktuálně spravujeme více než 2 600 bytů v hodnotě přes 18 miliard.",
    image: {
      src: "/img/scenes/NewHomepage/guy-sofa.webp",
      style: {
        position: "relative",
        bottom: "-20px",
        left: "-40px",
        objectFit: "cover",
        marginTop: "auto",
      },
    },
    href: "https://idealninajemce.cz/",
    gridItemSetting: { h: { base: "360px", md: "500px" }, flex: 1 },
  },
  {
    type: "GRAY_DARK_REVERT",
    title: "Prověření rizikovosti osob",
    subtitle:
      "V Česku má exekuci každý desátý. Vytvořili jsme nástroj, který zájemce prověří v 12 českých a slovenských rejstřících.",
    image: {
      src: "/img/scenes/NewHomepage/reportProvereneOsoby.webp",
      style: {
        position: "relative",
        bottom: "-40px",
        left: "-20px",
        objectFit: "cover",
        marginTop: "auto",
      },
    },
    to: "/provereni-rizikovosti-osob",
    gridItemSetting: { h: { base: "360px", md: "500px" }, flex: 1 },
  },
];

const CardsSection = () => (
  <CustomWrapper maxW="1360px" my={{ base: "40px", md: "80px" }}>
    <Heading
      variant="h2"
      textAlign="center"
      fontSize={{ base: "28px", md: "36px" }}
    >
      Na realitním trhu jsme jako doma
    </Heading>
    <Stack
      direction={{ base: "column", md: "row" }}
      mt={{ base: "24px", md: "40px" }}
      spacing={{ base: "20px" }}
      cursor="pointer"
    >
      {items.map(
        (
          { title, subtitle, image, type, gridItemSetting, href, to },
          index,
        ) => (
          <CardMotion
            key={index}
            content={
              <CardVariant
                type={type}
                title={title}
                image={image}
                subTitle={subtitle}
                to={to}
                href={href}
              />
            }
            gridItemSetting={gridItemSetting}
          />
        ),
      )}
    </Stack>
  </CustomWrapper>
);
export default CardsSection;
